var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('toolbar-option',{attrs:{"message":_vm.message}},[_c('template',{slot:"primary"},[_c('dropdown',{attrs:{"placeholder":"Select a Tag","options":_vm.htmlOptions,"value":_vm.htmlTag,"native":""},on:{"input":_vm.onInput}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }